module.exports = __webpack_public_path__ + "static/media/photo_coree.88901c4a.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Element/img/photo_coree.png
// module id = 262
// module chunks = 0